export const GLOBAL: Partial<Record<NDS.GlobalScreenNames, string>> = {
	END_OF_SURVEY: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>"Submit" button</td>
                    <td>GLOBAL</td>
                    <td>THANK_YOU</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>Clicking "Submit" will do the final (hard) submit (NOT IMPLEMENTED) and redirect to the Thank You page (NOT IMPLEMENTED)</p>
            <p>The BACK button is not available here - this is to stop the user from going back and changing answers about their dog as this could mess up the state</p>
            </div>
    `,
};
